import { SXModalBase } from "./SXModal";
import { useState } from "react";
import { Container, Row, Col, Form, Button, Tabs, Tab } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AdminViewModal } from "@common/components/ui-components/SXAdminView";
import type { FeatureFlag } from "@common/types/featureFlags";
import { useProject } from "../../features/projects/projectSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectFeatureFlags, setFeatureFlag } from "../../features/ui/uiSlice";
import { FEATURE_FLAG_DEFINITIONS } from "../../features/ui/featureFlags";

export function AdminViewWrapperModal(props: { close: () => void; isModalOpen: boolean }) {
  const [projectId, setProjectId] = useState("0");
  const [error, setError] = useState("");
  const { t, i18n } = useTranslation();
  const toggleSurvicateVisibility = () => {};

  // The admin view renders whatever flags it is handed; sx-column is what knows they exist and
  // where their state lives.
  const dispatch = useDispatch();
  const flagValues = useSelector(selectFeatureFlags);
  const featureFlags: FeatureFlag[] = FEATURE_FLAG_DEFINITIONS.map((definition) => ({
    ...definition,
    enabled: !!flagValues[definition.key],
  }));

  const getProjectData = async () => {
    //  http.formPost("/api/projects/all", { name: "projects.csv" }, true);
  };

  const body = () => {
    return (
      <Container>
        <AdminViewModal
          close={props.close}
          featureFlags={featureFlags}
          onFeatureFlagChange={(key, enabled) => dispatch(setFeatureFlag({ key, enabled }))}
        />
      </Container>
    );
  };
  const footer = (
    <>
      <Container>
        <Row>
          <Col lg={10}>
            <Button className="modal-btn" onClick={getProjectData}>
              Export Project Data
            </Button>
          </Col>
          <Col>
            <Button className="modal-btn" onClick={() => props.close()}>
              {t("close_.label")}
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );

  return (
    <SXModalBase size="xl" header={"Admin View"} show={props.isModalOpen} footer={footer} body={body()}></SXModalBase>
  );
}
